<template lang="pug">
div
  l-marker(
    ref="cmarkers"
    v-for="({ properties, geometry }) in refugios.features"
    :lat-lng="[geometry.coordinates[1], geometry.coordinates[0]]"
    :icon="buildIcon(properties)"
    :id="`refugio-mrk-${properties.nro}`"
    :key="`refugio-mrk-${properties.nro}`"
    @click="showDetalle(properties)"
    @ready="setMarkerObject($event, properties.nro)"
    )
    l-tooltip(:options="tooltipOptions")
      h4 Albergue: {{properties["nombre"]}}
      .datos
        div(v-show="properties.estadoCenso === estadoRefugios.censado") Censado en el año {{refugiosYear}}
        div(v-show="properties.estadoCenso === estadoRefugios.noCensado") No censado en el año {{refugiosYear}}
</template>

<script>
import L from 'leaflet'
import { mapGetters } from 'vuex'
import { estadoRefugios, tooltipOptions } from '@/constants.js'
import markerMixin from '@/mixins/marker.js'

export default {
  mixins: [ markerMixin ],
  data: () => ({
    tooltipOptions,
    estadoRefugios,
    markerDataIdProperty: 'nro'
  }),
  methods: {
    buildIcon (refugio) {
      let clazz = ''
      if (refugio.estadoCenso) {
        clazz = this.getClassName(refugio.estadoCenso)
      }
      return L.divIcon({
        className: `makerBlueIcon refugio-${clazz}`,
        html: `
          <div>
            <div class="ap-pin">
              <span class="ap-Refuge sub-icon">
              </span>
            </div>
          </div>
        `,
        iconSize: [45, 45]
      })
    },
    showDetalle (refugio = {}) {
      if (refugio.estadoCenso !== estadoRefugios.censado) return
      this.$emit('show-detail', { refugio })
    },
    getClassName (estado) {
      const splited = estado.toLowerCase().split(' ')
      return `${splited[0]}${splited[1] ? '-' + splited[1] : ''}`
    }
  },
  computed: {
    ...mapGetters({ refugios: 'refugios', refugiosYear: 'refugiosYear', markerData: 'currentRefugio' })
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/refugios/variables'
.leaflet-tooltip-pane
  .datos
    font-size: $f13px
    color: $color_0
  h4
    color: $color_0
    font-size: $f15px
    font-weight: bold
    margin: 0

</style>
